
<div class="toast-container">
  <div class="dismiss-all-container" *ngIf="(toastService.toasts$ | async)!.length > 1">
    <button class="dismiss-all-btn" (click)="dismissAll()">
      {{ 'COMMON.DISMISS_ALL' | translate }}
    </button>
  </div>

  <div *ngFor="let toast of (toastService.toasts$ | async); trackBy: trackByToastId" class="toast slide-in-transition"
    [ngClass]="'toast-' + toast.type"
    [attr.data-toast-id]="toast.id">

    <div class="toast-content">
      <div class="toast-icon">
         <img
          class="icon-image"
          [src]="toast.type | iconPath"
          [alt]="toast.type | iconAlt">
      </div>

      <div class="toast-message">{{ toast.message }}</div>
      <button class="toast-close" (click)="removeToast(toast.id)">×</button>

    </div>
    <div class="toast-progress-bar" [attr.data-toast-id]="toast.id"></div>
  </div>
</div>
